import { DataProxy } from 'apollo-cache';
import produce from 'immer';

import { PagesQuery } from '../../generated/graphql';
import { pagesQuery } from '../../components/LeftContainer/graphql';

function updatePageItem<T extends any>(cache: DataProxy, pageId: number, itemId: number, item: T): void {
  if (!item) {
    return;
  }

  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;
  const updatedPages = produce(pages, (draft: PagesQuery['pages']) => {
    const page = draft.find(p => p.id === pageId);

    if (page) {
      page.items = page.items || [];
      let pageItem = page.items.find(i => i.id === itemId);
      if (pageItem) {
        Object.assign(pageItem, item);
      }
    }
  });
  cache.writeQuery({
    query: pagesQuery,
    data: { pages: updatedPages },
  });
}
export default updatePageItem;
